import { createClient } from '@supabase/supabase-js'

// Project credentials from connected Supabase project
const SUPABASE_URL = 'https://pgxhazerbyqvzhoohpkp.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBneGhhemVyYnlxdnpob29ocGtwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg0Nzg5MzYsImV4cCI6MjA3NDA1NDkzNn0.-IBL98H99A2c_s3w7A7lhalZqwMv2gxjlv7htpjOjwo'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase